
import { ref,reactive,watch, toRefs,shallowRef} from 'vue'
import {Toast} from 'vant'
import {useRoute } from "vue-router";

export default {
  props:{
     shareShow:{
       type:Boolean
     },
      modelValue: {
      type: String,
      default: "",
    },
  },
  setup(props:any,{emit}:any){   
    const route: any = useRoute();
    let shareParams = reactive(JSON.parse(sessionStorage.getItem('shareParams') || '{}'))
    let copy_cont = ref(shareParams.con + ' ' + shareParams.url)
     watch(() => route.path, (state) => { 
      shareParams =  JSON.parse(sessionStorage.getItem('shareParams') || '{}')

      copy_cont.value = shareParams.con + shareParams.url
    });
    const options = [
      { name: 'Facebook', icon: 'wechat' },
      { name: 'Twitter', icon: 'weibo' },
      { name: 'Copy Link', icon: 'link' },
    ];
    let showShare = ref<Boolean>(false);

   let {modelValue} = toRefs(props)
    let shareCon = (type:Number)=>{
            switch(type){
                case 2:
                  var facebookTmp = 'https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(shareParams.url)+'&picture='+encodeURIComponent('http://image.kilimall.com/app/share_cash_rewards.png')+'&title='+encodeURIComponent(shareParams.con)+'&description=.';
                    window.open(facebookTmp,'sharer','toolbar=0,status=0,width=626,height=436');
                    break;  
                case 3:
             let twitterUrl='https://twitter.com/intent/tweet?text='.concat(encodeURIComponent(shareParams.con))+'&url='.concat(encodeURIComponent(shareParams.url));
                    window.open(twitterUrl);
                    break;    
            }
            showShare.value = false;
            
    };
      let close = () => {
     showShare.value = false;
    };
     const cancelBtn = ()=>{      
          emit('shareShow',false)
     }
       const onSuccess = () => {
         Toast('Copy success')
         showShare.value = false;
    }

    const onError = () => {
      Toast('Copy the failure')
      showShare.value = false;
    }

     watch(modelValue,(state:Boolean)=>{
        showShare.value = state;
     })
     watch(showShare,(state:Boolean)=>{
        emit("update:modelValue", state);
     })
    return {
      cancelBtn,
      shareCon,
       options,
      showShare,
      close,
      onSuccess,
      onError,
      copy_cont
    }
  }
}
